import { markSizes, type MarkSize } from '../../design/tokens'

/**
 * Marque à deux lettres — section 03.2 : « un carré coloré portant deux lettres, jamais une
 * illustration ». C'est elle qui porte l'information quand la couleur ne le peut pas, d'où le
 * plancher de taille de la correction E9.
 */
export function CategoryMark({
  initials,
  hue,
  size = 'large',
}: {
  initials: string
  hue: number
  size?: MarkSize
}) {
  const { square, font } = markSizes[size]

  return (
    <span
      aria-hidden="true"
      className="flex shrink-0 items-center justify-center rounded-field font-semibold"
      style={{
        width: square,
        height: square,
        fontSize: font,
        background: `var(--color-cat-${hue}-mark)`,
        // Jeton dédié et non « text-card » : en mode sombre, « card » est foncé et les lettres
        // disparaîtraient sur leur carré coloré.
        color: 'var(--color-on-mark)',
      }}
    >
      {initials}
    </span>
  )
}
